import { post } from '../http/client';
import type { EnquiryPayload, EnquiryRequestDto, EnquirySuccessResponse } from './Enquiry.types';
import { mapEnquiryPayloadToRequestDto, mapEnquirySuccessResponse } from './Enquiry.mapper';
import { apiEndpoints } from '@/config/apiEndpoints';

export const submitEnquiry = async (payload: EnquiryPayload): Promise<EnquirySuccessResponse> => {
  const requestBody: EnquiryRequestDto = mapEnquiryPayloadToRequestDto(payload);

  const response = await post<EnquirySuccessResponse>(apiEndpoints.enquiry, requestBody, {
    cache: 'no-store',
    timeoutMs: 10000,
  });

  return mapEnquirySuccessResponse(response.data);
};
